var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSummaryicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39706 1.54102C11.3919 1.54102 12.8893 1.54102 13.8196 2.4197C14.75 3.29838 14.75 4.71259 14.75 7.54102V10.541C14.75 13.3694 14.75 14.7837 13.8196 15.6623C12.8893 16.541 11.3919 16.541 8.39706 16.541H7.60294C4.60814 16.541 3.11073 16.541 2.18037 15.6623C1.25 14.7837 1.25 13.3694 1.25 10.541L1.25 7.54101C1.25 4.71259 1.25 3.29837 2.18037 2.41969C3.11073 1.54102 4.60814 1.54102 7.60294 1.54102L8.39706 1.54102Z",
    stroke: "#008080",
    strokeWidth: 1.18421,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.29102H11",
    stroke: "#008080",
    strokeWidth: 1.18421,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.04102H11",
    stroke: "#008080",
    strokeWidth: 1.18421,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.791H8",
    stroke: "#008080",
    strokeWidth: 1.18421,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryicon);
export default __webpack_public_path__ + "static/media/summaryicon.6f4c96c01e9fa3bc083b0e5027bb8cd7.svg";
export { ForwardRef as ReactComponent };